import { mapActions } from 'vuex';

export default {
  mounted() {
    this.$nextTick(() => {
      this.getNotifyMessage().then((notify) => {
        if (notify) {
          this.$toast.open(notify);
        }
      });
    });
  },
  methods: {
    ...mapActions(['getNotifyMessage']),
  },
};



// WEBPACK FOOTER //
// ./src/mixins/notify.js